import {
  integer,
  round1,
  round2,
  ratioToPercent,
  per100,
} from '../../lib/format';

const valueNumber = value => `${value}`;

export function title(stat) {
  return {
    possessions_per_game: 'Possessions Played Per Game',
    points_per_possession: 'Points Scored Per 100 Possessions',
    points: 'Points Per Game',
    fg_perc: 'Field Goal %',
    fg3_perc: 'Three Point Field Goal %',
    fg2_perc: 'Two Point Field Goal %',
    ft_perc: 'Free Throw %',
    fg3_par: 'Three Point Field Goal Attempt Rate',
    atr: 'At The Rim Field Goal %',
    atr_perc: '% of Field Goals at the Rim',
    'fg%': 'Field Goal %',
    'fg3%': 'Three Point Field Goal %',
    'fg2%': 'Two Point Field Goal %',
    'ft%': 'Free Throw %',
    'fg3 par': 'Three Point Field Goal Attempt Rate',
    pps: 'Points Scored Per Shot',
    ts: 'True Shooting %',
    true_shooting: 'True Shooting %',
    efg: 'Effective Field Goal %',
    orr: 'Offensive Rebound Rate',
    ftr: 'Free Throw Rate',
    tov: 'Turnover Percentage',
    possessions: 'Total Possessions Played',
    plus_minus: 'Total Plus Minus',
    pts: 'Points',
    fgm: 'Field Goals',
    fga: 'Field Goal Attempts',
    fgm3: '3-Point Field Goals',
    fga3: '3-Point Field Goal Attempts',
    ft: 'Free Throws',
    fta: 'Free Throw Attempts',
    rebs: 'Rebounds',
    rebsd: 'Defensive Rebounds',
    rebso: 'Offensive Rebounds',
    orebs: 'Offensive Rebounds',
    drebs: 'Defensive Rebounds',
    ast: 'Assists',
    blk: 'Blocks',
    stl: 'Steals',
    to: 'Turnovers',
    fouls: 'Fouls',
    g: 'Games',
    mp: 'Minutes Played',
    min: 'Minutes',
    usg: 'Usage %',
    pos: 'Possessions',
    atr_percentage: 'FG% - Rim',
    mid_percentage: 'FG% - Mid-range',
    three_percentage: 'FG% - Three',
    atr_rate: '% of Shots - Rim',
    mid_rate: '% of Shots - Mid-range',
    three_rate: '% of Shots - Three',
    'ast%': 'Assist %',
    assist_percentage: 'Assist %',
    ato: 'Assist to Turnover Ratio',
    pps_noft: 'Points/Shot (w/o Free Throws)',
    total_factored_net_rating: 'Factored Net Rating',
    total_factored_opp_points_poss: 'Opp. Points/Possession',
    total_factored_points_poss: 'Points/Possession',
    pp40: 'Poss./40 mins',
    pp48: 'Poss./48 mins',
  }[stat];
}

export function value(stat, value) {
  return {
    possessions: integer,
    possessions_per_game: integer,
    plus_minus: round1,
    points_per_possession: per100,
    points: round1,
    fg_perc: ratioToPercent,
    fg3_perc: ratioToPercent,
    fg2_perc: ratioToPercent,
    ft_perc: ratioToPercent,
    fg3_par: ratioToPercent,
    atr: ratioToPercent,
    atr_rate: ratioToPercent,
    pps: round2,
    true_shooting: ratioToPercent,
    efg: ratioToPercent,
    orr: ratioToPercent,
    ftr: ratioToPercent,
    tov: ratioToPercent,
    pts: valueNumber,
    fgm: valueNumber,
    fga: valueNumber,
    fgm3: valueNumber,
    fga3: valueNumber,
    ft: valueNumber,
    fta: valueNumber,
    rebs: valueNumber,
    rebsd: valueNumber,
    rebso: valueNumber,
    ast: valueNumber,
    blk: valueNumber,
    stl: valueNumber,
    to: valueNumber,
    fouls: valueNumber,
    assist_percentage: ratioToPercent,
    ato: round2,
  }[stat](value);
}
